import _ from "../../config/AppConfig";

export default _;
